<template>
  <div>
    <div class="group-status">
      <template v-for="x in status">
        <div :key="x.index">
          <div class="status">
            <div
              :class="{
                color: true,
                red: x.color == 'แดง',
                yellow: x.color == 'เหลือง',
                pink: x.color == 'ชมพู',
                blue: x.color == 'ฟ้า',
                green: x.color == 'เขียว',
                gray: x.color == 'เทา',
                orange: x.color == 'ส้ม',
                purple: x.color == 'ม่วง',
              }"
            />
            <span style="margin-left:5px;">{{ x.meaning }}</span>
          </div>
        </div>
      </template>
    </div>
    <b-container id="form" fluid>
      <b-row>
        <b-col cols="auto">
          <div
            class="datepicker-trigger input-group"
            @mouseover="activeCloseDate = true"
            @mouseleave="activeCloseDate = false"
          >
            <input
              id="datepicker-trigger"
              class="form-control border-right-0"
              type="text"
              autocomplete="off"
              placeholder="เลือกวันที่"
              :value="formatDates(date)"
            />
            <div class="input-group-prepend bg-white">
              <span
                id="basic-addon1"
                class="input-group-text border-left-0 rounded-right bg-white"
                ><fa-icon
                  :style="{
                    opacity: activeCloseDate ? 1 : 0,
                  }"
                  :icon="['fas', 'times']"
                  class="icon"
                  @click="clearDate"
                />
              </span>
            </div>

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger'"
              :mode="'single'"
              :show-shortcuts-menu-trigger="false"
              :fullscreen-mobile="true"
              :months-to-show="1"
              :date-one="date"
              @date-one-selected="
                (val) => {
                  date = val;
                  setDate(date);
                }
              "
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-table
      id="quality-control-table"
      :items="items"
      :fields="fields"
      striped
      bordered
      responsive
      :tbody-tr-class="rowClass"
    >
      <template slot="no" slot-scope="data">
        <div class="col-right">
          {{ data.index + 1 }}
        </div>
      </template>
      <template slot="Test Item" slot-scope="data">
        <div class="col-right">
          {{ data.item.test_item }}
        </div>
      </template>
      <template slot="Lot No." slot-scope="data">
        <div class="col-right">
          {{ data.item.lot_no }}
        </div>
      </template>
      <template slot="QC Name" slot-scope="data">
        <div class="col-left">
          {{ data.item.qc_name }}
        </div>
      </template>
      <template slot="Target Mean" slot-scope="data">
        <div class="col-left">
          {{ data.item.target_mean }}
        </div>
      </template>
      <template slot="Target SD" slot-scope="data">
        <div class="col-left">
          {{ data.item.target_sd }}
        </div>
      </template>
      <template slot="Result" slot-scope="data">
        <div class="col-left">
          {{ data.item.result }}
        </div>
      </template>
      <template slot="Qc Regulation" slot-scope="data">
        <div class="col-left">
          {{ data.item.qc_regulation }}
        </div>
      </template>
      <template slot="สถานะ" slot-scope="data">
        <div
          :class="{
            color: true,
            red: data.item.status_id == '1',
            yellow: data.item.status_id == '2',
            pink: data.item.status_id == '3',
            blue: data.item.status_id == '4',
            green: data.item.status_id == '5',
            gray: data.item.status_id == '6',
            orange: data.item.status_id == '7',
            purple: data.item.status_id == '8',
          }"
        />
      </template>
    </b-table>
    <button
      type="button"
      class="btn report-btn btn-primary mr-2"
      @click="printQC"
    >
      REPORT
    </button>
    <button
      type="button"
      class="btn approve-btn btn-primary ml-2"
      @click="approve"
    >
      APPROVE
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";
import format from "date-fns/format";
import print from "print-js";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    // Datepicker
  },
  data() {
    return {
      activeCloseDate: false,
      fields: [
        "no",
        "Test Item",
        "Lot No.",
        "QC Name",
        // A column that needs custom formatting
        "Target Mean",
        "Target SD",
        // A regular column
        "Result",
        // A regular column
        "Qc Regulation",
        "สถานะ",
      ],
      dateFormat: "YYYY-MM-DD",
      date: "",
      today: { date: moment.tz("Asia/Bangkok").format("YYYY-MM-DD") },
    };
  },
  created() {},
  async mounted() {
    var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
    const res = { date: today };
    await this.qualityDate(res);
  },
  computed: {
    ...mapGetters({
      items: "QualityControl/getQualityDate",
      status: "Status/getAll",
    }),
  },
  methods: {
    approve() {
      const res = { date: this.date };
      this.approveQuality(res);
    },
    printQC() {
      printJS({
        printable: this.items,
        type: "json",
        properties: [
          { field: "test_item", displayName: "Test Item" },
          { field: "lot_no", displayName: "Lot No." },
          { field: "qc_name", displayName: "QC Name" },
          { field: "target_mean", displayName: "Target Mean" },
          { field: "target_sd", displayName: "Target SD" },
          { field: "result", displayName: "Result" },
          { field: "qc_regulation", displayName: "QC Regulation" },
        ],
        header: '<h1 class="custom-h1 text-center">QC Test Item</h1>',
        style: ".custom-h1 { color: black; text-align: center;}",
        gridHeaderStyle:
          "border-bottom: 1px solid black; border-top: 1px solid black",
        gridStyle: "text-align: center; padding: 10px 0",
      });
    },
    // eslint-disable-next-line
    rowClass(item, type) {
      if (item.emergency_level == 1) {
        return "highlight";
      } else {
        return;
      }
    },
    ...mapActions({
      qualityDate: "QualityControl/qualityDate",
      setStatus: "Status/setAll",
      approveQuality: "QualityControl/approveQuality",
    }),
    formatDates(date) {
      let formattedDates = "";
      if (date) {
        formattedDates = format(date, this.dateFormat);
      }
      return formattedDates;
    },
    setDate(date) {
      const res = { date: this.formatDates(date) };
      this.qualityDate(res);
    },
    clearDate() {
      this.date = "";
      var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
      const res = { date: today };
      this.qualityDate(res);
    },
  },
};
</script>

<style scoped>
#form {
  background-color: #eaeced;
  padding: 5px;
  /* margin-left: 1px;
  margin-right: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center; */
  /*height: 50px;*/
  /* padding: 0.5rem; */
}
.left {
  text-align: left;
}
.search-box {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.search {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
input[type="search"] {
  margin-left: 5px;
  width: 22%;
}
.select-box {
  margin: 0px 5px 0px 5px;
  width: 20vw;
}
.search-icon {
  align-self: center;
  margin: 0px 0px 0px 10px;
  color: black;
}
.flex {
  display: flex;
  margin-right: 10px;
  margin-left: 5px;
}
a {
  color: black;
  cursor: pointer;
}
.text-red {
  color: red;
}
.text-orange {
  color: orange;
}
.date-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 15.5vw;
}
.icon {
  cursor: pointer;
}
.color {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  align-self: center;
  margin: 0 auto;
  justify-content: center;
}
.group-status {
  display: flex;
  margin-bottom: 5px;
}
.status {
  display: flex;
  margin-right: 20px;
}
.red {
  background-color: red;
}
.yellow {
  background-color: #ffe927;
}
.pink {
  background-color: pink;
}
.blue {
  background-color: #00d0ec;
}
.purple {
  background-color: #7202ec;
}
.green {
  background-color: #48e100;
}
.gray {
  background-color: gray;
}
.orange {
  background-color: #fb822b;
}
.approve-btn {
  background-color: #009906;
  border: none;
}

.reject-btn {
  background-color: #e20000;
  border: none;
}
.report-btn {
  background-color: #fd881e;
  border: none;
}
</style>

<style>
.date-box {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
}
</style>

<style lang="scss">
@media print {
  #quality-control-table {
    color: #333;
    border: 1px solid #aaa;
  }
}
</style>
